/*
 * @Author: “zhaoh” “zhaohang0805@qq.com”
 * @Date: 2020-05-24 21:56:40
 * @LastEditors: “zhaoh” “zhaohang0805@qq.com”
 * @LastEditTime: 2024-01-18 10:49:18
 * @FilePath: \cshf\src\http\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const api ={
    home:{
        hotProjectList:'/home/hotProjectList', //热门新盘
        secondHouseList:'/home/secondHouseList',//二手房
        officeList:'/home/officeList',//GET  写字楼
        shopsList:'/home/shopsList',//优质好铺
        hotBusiness:'/home/hotBusiness',//热门商圈
        recommendHouseList:'/home/recommendHouseList',//推荐房源
    },
    common:{
        allDictType:'/common/allDictType', //字典数据
        allBusiness:'/common/allBusiness',//所有商圈列表
        businessList:'/common/businessList',//商圈列表
        cityregion:'/common/city_region',//当前城市行政区
        metroList:'/common/metroList', //获取地铁线
        search:'/common/searchFilter' //获取地铁线
    },
    second:{
        pageList:'/second/house/pageList',//二手房列表
    },
    officeBuild:{
        sellList:'/office/sellList',//写字楼列表
        getSellOffice:'/office/getSellOffice',//出售写字楼详情
        pageImage:'/office/pageImage',//房源图片
        pageOfficeInfoImage:'/office/pageOfficeInfoImage',//楼盘图片
        leaseList:'/office/leaseList',//出租
        pageFollow:'/office/pageFollow',//跟进情况
        getLeaseOffice:'/office/getLeaseOffice',//出租详情 
        getAgent:'/office/getHouseAgent',//获取经纪人
        pageList:'/office/pageList',//楼盘列表,
        getOfficeInfo:'/office/getOfficeInfo',//楼盘详情 
        recommendLeaseList:'/office/recommendLeaseList',//出租推荐
        recommendSellList:"/office/recommendSellList",//出售推荐

    },
    newHouse:{
        pageList:'/project/pageList',
        projectInfo:'/project/projectInfo',
        projectImagelist:'/project/projectImagelist',
    },
    Code:{
        sendCode:'/entrust/sendCode',//获取验证码
        saveEntrust:'/entrust/saveEntrust',//委托找房 
    },
    entrust:{
        save:'/entrust/saveEntrust1',//新房列表
    }
    
}
export default api


// WEBPACK FOOTER //
// ./src/http/api.js